export const hotkeyDescriptions = {
  toggleMic: '(Ctrl/Cmd + Shift + M) Enable/disable microphone',
  toggleWebcam: '(Ctrl/Cmd + Shift + V) Enable/disable webcam',
  endCall: '(Escape) End the call',
  toggleFullScreen: '(Ctrl/Cmd + Shift + F) Enter/exit fullscreen mode',
  toggleCaptions: '(Ctrl/Cmd + Shift + C) Enable/disable captions'
};
